<template>
  <div class="skin-variables">
    <p v-if="item.graffityTypes?.length" class="skin-title">{{ $t('family_skins') }}</p>
    <div class="skin-variables_wrap">
      <UiCollapse
          v-if="stattrakOrSouvenirItems.length > 1 || (normalItems.length && stattrakOrSouvenirItems.length)"
          :default-expanded="(item.is_stattrak || item.is_souvenir)"
          :items="stattrakOrSouvenirItems"
      >
        <template #label>
          {{
            t('show_variable_items', {
              name: includeStatTrak ? 'StatTrak' : includeSouvenir ?
                  'Souvenir' : ''
            })
          }}
        </template>
        <template #items>
          <div class="skin-variables_wrap">
            <template
                v-for="volume of stattrakOrSouvenirItems">
              <div
                  v-if="volume.full_name"
                  class="skin-variables--item card-dark hover px14 py5"
              >
                <!--                  :class="{-->
                <!--                      active: normalItems?.length === 0 && stattrakOrSouvenirItems.length === 1 ||-->
                <!--                      getExterior(volume.full_name) === item.exterior && (item.is_stattrak || item.is_souvenir)-->
                <!--                    }"-->
                <NuxtLink
                    :aria-label="volume.full_name"
                    :class="{loading : volume.full_name === loadingItemName}"
                    :to="getItemLinkWithExterior({
                      name: volume.full_name || '',
                      slug: volume.link
                    })"
                    class="skin-variables--item_link"
                    exact-active-class="active"
                    @click="loadingItemName = volume.full_name"></NuxtLink>

                <div
                    class="skin-variables--item_row f"
                >
                  <p class="skin-variables--item-title f gap8">
                    <span class="ell">
                    {{ $t(getExterior(volume.full_name)) }}
                    </span>
                    <span
                        :class="[
                          getPropertyCondition(volume.full_name || '').toLowerCase(),
                        ]">
                      {{
                        getPropertyCondition(volume.full_name) === "StatTrak" ? "ST" : "SV"
                      }}
                    </span>
                  </p>
                  <p class="skin-variables--item-price">
                    <!--                    <client-only>-->
                    <LazyUiPrice
                        v-if="volume.min_price"
                        :price="volume.min_price"
                    />
                    <span v-else>
                        --
                    </span>
                    <!--                    </client-only>-->
                  </p>
                </div>
              </div>
            </template>
          </div>
        </template>
      </UiCollapse>

      <template
          v-if="normalItems.length > 1 || (normalItems.length && stattrakOrSouvenirItems.length)">
        <div
            v-for="volume of (showMoreToggle ? normalItems : normalItems.slice(0, 10))"
            :key="volume.full_name"
            class="skin-variables--item card-dark hover px14 py5"
        >
          <!--            :class="{-->
          <!--              active: normalItems?.length === 1 && stattrakOrSouvenirItems.length === 0 ||-->
          <!--              getExterior(volume.full_name) === item.exterior && !item.is_stattrak && !item.is_souvenir-->
          <!--            }"-->
          <NuxtLink
              :aria-label="volume.full_name"
              :class="{loading : volume.full_name === loadingItemName}"
              :to="getItemLinkWithExterior({
              name: volume.full_name,
              slug: volume.link
            })"
              class="skin-variables--item_link"
              exact-active-class="active"
              @click="loadingItemName = volume.full_name"
          ></NuxtLink>
          <div
              class="skin-variables--item_row f"
          >
            <div class="f gap4">
              <img
                  v-if="item.graffityTypes?.length"
                  :src="getImageFromWaxpeer(volume.link, '50:50')"
                  alt=""
                  height="32"
                  loading="lazy"
                  width="32"
              >
              <p class="skin-variables--item-title ell">
                {{
                  (getExterior(volume.full_name) && $t(getExterior(volume.full_name))) ||
                  item.locals?.rarity || item.locals?.localed_name
                }}
              </p>
            </div>
            <div class="skin-variables--item-price">
              <!--            <client-only>-->
              <LazyUiPrice v-if="volume.min_price" :price="volume.min_price" />
              <span v-else>
                  --
              </span>
              <!--            </client-only>-->
            </div>
          </div>
        </div>

        <button
            v-if="normalItems.length > 10"
            :class="{active: showMoreToggle}"
            class="btn btn-primary btn-more"
            @click="showMoreToggle = !showMoreToggle"
        >
          {{ showMoreToggle ? t('show_less') : t('show_more') }}
          <span class="i-arrow"></span>
        </button>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n'
import {ref} from 'vue'
import type {GraffityType, ItemPageInfo, Volume} from "~/graphql/generated/schema-types";

interface IVolume {
  full_name: string,
  min_price: number,
  last_update: string,
  market: string,
  offers: number,
  link: string
}

const props = defineProps<{
  item: ItemPageInfo
  variables: Volume[]
}>()

const config = useRuntimeConfig()
const siteHost = config.public.siteHost
const {t, locale} = useI18n()

const normalItems = ref([] as IVolume[]);
const stattrakOrSouvenirItems = ref([] as IVolume[]);
const active = ref<string | null>(null)
const includeStatTrak = ref(false)
const includeSouvenir = ref(false)
const loadingItemName = ref('')
const showMoreToggle = ref(false)

const getPropertyCondition = (name?: string): 'StatTrak' | 'Souvenir' | '' => {
  if (!name) return ''
  return getModifiedString(name).includes('stattrak') ? 'StatTrak' : 'Souvenir'
};


watch(toRef(props.variables), setVariables, {immediate: true})

function setVariables() {
  if (props.item.graffityTypes?.length) {
    props.item.graffityTypes.forEach((type: GraffityType) => {
      const volume = props.variables.find(item => item.link === type.link_name);
      normalItems.value.push({
        full_name: `(${type.color})`,
        link: type.link_name || '',
        min_price: volume?.min_price!,
        last_update: volume?.last_update!,
        market: volume?.market!,
        offers: volume?.offers!,
      })
    })

    const activeItemIndex = normalItems.value.findIndex(item => item.link === props.item.link);

    if (activeItemIndex !== -1) {
      // Извлекаем активный элемент из списка
      const [activeItem] = normalItems.value.splice(activeItemIndex, 1);
      // Добавляем активный элемент в начало списка
      normalItems.value = [activeItem, ...normalItems.value];
    }

    return
  }

  props.variables.forEach(item => {
    if (item.extra_full_name) {
      if (item.extra_full_name?.includes('StatTrak') || item.extra_full_name?.includes('Souvenir')) {
        if (!includeStatTrak.value && item.extra_full_name?.includes('StatTrak')) {
          includeStatTrak.value = true
        }
        if (!includeSouvenir.value && item.extra_full_name?.includes('Souvenir')) {
          includeSouvenir.value = true
        }

        stattrakOrSouvenirItems.value.push({
          full_name: item.extra_full_name,
          link: item.extra_link || '',
          min_price: item.extra_price!,
          last_update: item.extra_last_update!,
          market: item.extra_market!,
          offers: item.extra_offers!,
        });
      } else {
        normalItems.value.push({
          full_name: item.extra_full_name,
          link: item.extra_link || '',
          min_price: item.extra_price!,
          last_update: item.extra_last_update!,
          market: item.extra_market!,
          offers: item.extra_offers!,
        });
      }
    }

    if (item.full_name?.includes('StatTrak') || item.full_name?.includes('Souvenir')) {
      if (!includeStatTrak.value && item.full_name?.includes('StatTrak')) {
        includeStatTrak.value = true
      }
      if (!includeSouvenir.value && item.full_name?.includes('Souvenir')) {
        includeSouvenir.value = true
      }
      stattrakOrSouvenirItems.value.push({
        full_name: item.full_name,
        link: item.link,
        min_price: item.min_price!,
        last_update: item.last_update!,
        market: item.market!,
        offers: item.offers!,
      });
    } else {
      normalItems.value.push({
        full_name: item.full_name,
        link: item.link || '',
        min_price: item.min_price!,
        last_update: item.last_update!,
        market: item.market!,
        offers: item.offers!,
      });
    }
  });
}

</script>

<style lang="scss">


.skin-variables {
  margin: 0 !important;

  &_wrap {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 0.8rem;
    gap: 0.8rem;
  }

  &--item {
    color: var(--surfaces-on-surface-variable);
    position: relative;
    overflow: hidden;

    &:has(.skin-variables--item_link.active) {
      border: 1px solid var(--accent-primary);
      color: var(--accent-on-accent-secondary);
    }

    &_link {
      position: absolute;
      inset: 0;

      &.loading:after {
        content: '';
        display: block;
        position: absolute;
        inset: 0;
        z-index: 0;
        background: rgba(144, 128, 249, 0.51);
        width: 0;
        animation: slidebg 3s ease forwards;
      }


      @keyframes slidebg {
        to {
          width: 100%;
        }
      }

    }

    &_row {
      height: 4rem;
    }

    &-title {
      font-weight: 600;
      max-width: 145px;
    }

    &-price {
      color: var(--surfaces-on-surface);
      font-weight: 800;
      font-size: 1.6rem;
    }

    &-market {
      font-size: 1.2rem;
      font-weight: 600;

      img {
        border: 0;
      }
    }

    //&.active {
    //  border: 1px solid var(--accent-primary);
    //  color: var(--accent-on-accent-secondary);
    //}
  }

  .btn-more {
    min-height: 40px;
    font-weight: 600;

    .i-arrow {
      transform: rotate(0);
      transition: transform 0.3s;
    }

    &.active .i-arrow {
      transform: rotate(-180deg);
    }
  }
}

@media screen and (max-width: 1115px) {
  .skin-variables {
    margin: 3.2rem 0;

    .collapse_header__btn {
      padding-bottom: 1.6rem;
    }
  }
}
</style>
